<template>
  <a-modal
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @cancel="$emit('close')"
      @ok="handleSubmit"
      destroyOnClose
  >
    <a-form
        v-bind="formItemLayout"
        v-if="visible"
    >
      <a-form-item label="教材图片">
          <a-upload
                  name="avatar"
                  list-type="picture-card"
                  :show-upload-list="false"
                  action=""
                  :before-upload="beforeUpload"
                  @change="handleChange"
                  :customRequest="customRequest"
          >
              <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
              <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'" style="font-size:30px;color:#dcdcdc"/>
              </div>
          </a-upload>
          <span>大小不超过10M,格式为jpg</span>
      </a-form-item>
      <a-form-item label="名称">
        <a-input v-model="name" placeholder="请输入教材名称" />
      </a-form-item>
      <a-form-item label="主编">
        <a-input v-model="editor" placeholder="请输入教材主编" />
      </a-form-item>
      <a-form-item label="出版社">
        <a-input v-model=" publisher" placeholder="请输入教材出版社" />
      </a-form-item>
      <a-form-item label="出版年份">
        <a-month-picker v-model="years" placeholder="选择教材出版年份" :format="monthFormat"></a-month-picker>
<!--        <a-input v-model="years" placeholder="请输入教材出版年份" />-->
      </a-form-item>
      <a-form-item label="教材定价">
        <a-input v-model="price" placeholder="请输入教材定价" />
      </a-form-item>
      <a-form-item label="展示状态">
        <a-switch :defaultChecked="show" @change="setShow()"/>
      </a-form-item>
      
      <a-form-item v-if="false" label="分值分布" :label-col="{ span: 5 }" :wrapper-col="{ span: 18, offset: 1 }">
        <div v-for="(item, index) in scoreDistribution" :key="index" style="margin-bottom: 16px;">
          <a-row :gutter="16">
            <a-col :span="8">
              <a-input v-model="item.type" placeholder="题型" />
            </a-col>
            <a-col :span="6">
              <a-input-number 
                v-model="item.count" 
                :min="1" 
                placeholder="题数" 
                style="width: 100%"
              />
            </a-col>
            <a-col :span="6">
              <a-input-number 
                v-model="item.score" 
                :min="0" 
                :step="0.5" 
                placeholder="分值" 
                style="width: 100%"
              />
            </a-col>
            <a-col :span="4" style="text-align: right">
              <a-button 
                type="danger" 
                shape="circle" 
                icon="delete" 
                size="small" 
                @click="removeScoreItem(index)"
                :disabled="scoreDistribution.length <= 1"
              />
            </a-col>
          </a-row>
        </div>
        <a-button type="dashed" @click="addScoreItem" style="width: 100%; margin-top: 8px">
          <a-icon type="plus" /> 添加题型
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { uploadImg } from '@/libs/api'
import * as http from '@/libs/analysis'
export default {
  name: 'addCourseBook',
  props: [ 'visible', 'data' ],
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  watch:{
    visible(val){
      if(val){
        if(this.data.length == 0){
          this.title = "新增教材"
          this.name = ''
          this.editor = ''
          this.publisher = ''
          this.years = ''
          this.price = ''
          this.show = false
          this.imageUrl = ''
          this.scoreDistribution = [{ type: '', count: 1, score: 0 }]
        }else{
          this.title = "编辑教材"
          this.name = this.data.name
          this.editor = this.data.editor
          this.publisher = this.data.publisher
          this.imageUrl = this.data.image
          this.years = this.data.years
          this.price = this.data.price
          this.show = this.data.show
          try {
            this.scoreDistribution = this.data.score_distribution 
              ? JSON.parse(this.data.score_distribution) 
              : [{ type: '', count: 1, score: 0 }];
          } catch (e) {
            this.scoreDistribution = [{ type: '', count: 1, score: 0 }];
          }
        }
      }
    }
  },
  mounted(){
    if (this.$route.query.class)
      this.classId = this.$route.query.class;
  },
  data(){
    return{
      confirmLoading: false,
      loading: false,
      title: '',
      imageUrl: '',
      name: '',
      classId: '',
      editor: '',
      publisher: '',
      years: '',
      price: '',
      show: false,
      scoreDistribution: [
        { type: '', count: 1, score: 0 }
      ],
      monthFormat: 'YYYY-MM',
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 },
      },
      url:''
    }
  },
  methods:{
    addScoreItem() {
      this.scoreDistribution.push({ type: '', count: 1, score: 0 });
    },
    removeScoreItem(index) {
      if (this.scoreDistribution.length > 1) {
        this.scoreDistribution.splice(index, 1);
      }
    },
    setShow(e){
      this.show = !this.show;
    },
    handleSubmit(){
      // Validate score distribution
      const hasEmptyFields = this.scoreDistribution.some(item => !item.type || !item.count || item.score === null);
      if (hasEmptyFields) {
        this.$message.warning('请填写完整的分值分布信息');
        this.confirmLoading = false;
        return;
      }

      this.confirmLoading = true;
      const scoreDistribution = JSON.stringify(this.scoreDistribution);
      
      if(this.data.length == 0){
        http.add_course_book({
          class: this.classId, 
          name: this.name, 
          image: this.imageUrl, 
          editor: this.editor, 
          years: this.years, 
          price: this.price, 
          show: this.show, 
          publisher: this.publisher,
          score_distribution: scoreDistribution
        }).then(res=>{
          this.$emit('close')
          this.$emit('update')
          this.confirmLoading = false
        }).catch((error)=>{
          console.log(error)
          this.confirmLoading = false
        })
      }else{
        http.edit_course_book({
          name: this.name, 
          image: this.imageUrl, 
          editor: this.editor, 
          years: this.years, 
          price: this.price, 
          show: this.show, 
          publisher: this.publisher, 
          id: this.data.id,
          score_distribution: scoreDistribution
        }).then(res=>{
          this.$emit('close')
          this.$emit('update')
          this.confirmLoading = false
        }).catch((error)=>{
          console.log(error)
          this.confirmLoading = false
        })
      }
    },
    beforeUpload(){

    },
    customRequest(data){
      let formData = new FormData()
      formData.append('file',data.file)
      uploadImg(formData).then(res=>{
        if(res){
          this.imageUrl=res.fileUrl
        }
      },error=>{
        console.log(error)
      })
    },
    handleChange(){

    }
  }
}
</script>
